/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import WsCheckoutCartProductCard from '../ecommerce/webstore/sections/checkoutContent/WsCheckoutCartProductCard';

const CheckoutEcomStoreLineItem = ({
  lineItem,
  regCart,
  checkoutLineItemsInfo,
  onCustomize,
  onUpdateCartProducts,
  onRemoveCartProducts,
  onRemoveUnavailableProducts,
  onRedeemCoupon,
  submitting,
  isOrderHistory
}) => {
  const { regAssociation, ecomStoreCart } = regCart;
  const ecomStoreCartProduct = !isOrderHistory
    ? regCart.ecomStoreCart.ecomStoreCartProducts.find(
        (p) => p.pkEcomStoreCartProduct === lineItem.entityId
      ) ||
      regCart.ecomStoreCart.ecomStoreCartPackages.find(
        (p) => p.pkEcomStoreCartPackage === lineItem.entityId
      )
    : null;

  const ecomStoreCartPackage = !isOrderHistory
    ? regCart.ecomStoreCart.ecomStoreCartPackages?.find(
        (p) => p.pkEcomStoreCartPackage === lineItem.entityId
      )
    : null;

  return (
    <WsCheckoutCartProductCard
      key={lineItem.entityId}
      ecomStoreCart={ecomStoreCart}
      lineItem={lineItem}
      lineItemInfo={checkoutLineItemsInfo.find(
        (p) => p.entityId === lineItem.entityId
      )}
      onCustomize={(product) => {
        if (lineItem.isBundleProduct) {
          onCustomize({ ecomStoreCartPackage });
        }
        else {
          onCustomize({ ecomStoreCartProduct: product });
        }
      }}
      onRemove={onRemoveCartProducts}
      onRemoveUnavailableProducts={onRemoveUnavailableProducts}
      onUpdate={onUpdateCartProducts}
      productUrl={
        regAssociation
          ? `/association/${regAssociation.pkRegAssociation}${
              ecomStoreCartPackage
                ? `?urlHandle=${ecomStoreCartPackage.urlHandle}`
                : ecomStoreCartProduct
                ? `?product=${ecomStoreCartProduct.ecomStoreProductVariant.ecomStoreProduct.uuid}&variant=${ecomStoreCartProduct.ecomStoreProductVariant.ecomVendorProductVariant.uuid}`
                : ''
            }`
          : null
      }
      submitting={submitting}
    />
  );
};

CheckoutEcomStoreLineItem.propTypes = {
  checkoutLineItemsInfo: PropTypes.array,
  isOrderHistory: PropTypes.bool,
  lineItem: PropTypes.object,
  onCustomize: PropTypes.func,
  onRedeemCoupon: PropTypes.func,
  onRemoveCartProducts: PropTypes.func,
  onRemoveUnavailableProducts: PropTypes.func,
  onUpdateCartProducts: PropTypes.func,
  regCart: PropTypes.object,
  submitting: PropTypes.bool
};

export default CheckoutEcomStoreLineItem;
